module.exports = __webpack_public_path__ + "img/i_my_c_list.79406c7d.svg";